(() => {
  const init = () => {
    const slider = document.querySelector('testimonials-split-slider');
    if (!slider || slider.dataset.kbAccessible) return;
    slider.dataset.kbAccessible = 'true';
    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-label', 'Kinder Balance und seine Inhaltsstoffe');
    const sync = () => {
      slider.querySelectorAll('.testimonials-split-slider__media').forEach(panel => {
        const active = panel.classList.contains('active');
        panel.inert = !active;
        panel.setAttribute('aria-hidden', String(!active));
      });
      slider.querySelectorAll('.swiper-slide').forEach(panel => {
        const active = panel.classList.contains('swiper-slide-active');
        panel.inert = !active;
        panel.setAttribute('aria-hidden', String(!active));
      });
    };
    let frame;
    const observer = new MutationObserver(() => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = null; sync(); });
    });
    observer.observe(slider, {attributes: true, subtree: true, attributeFilter: ['class']});
    sync();
    window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
